module.exports = __webpack_public_path__ + "static/media/agent_icon.6ddfa7f9.svg";